import { waermepumpeEignungsAnalyse } from "./wizard-config-wpc";
import { heizungswegweiser } from "./wizard-config-wegweiser";
import { foerderung } from "./wizard-config-foerderung";
import { energieberatung } from "./wizard-config-energieberatung";
import { startSteps } from './wizard-config-start';

const addFieldNameToSteps = (steps) => {
  // Helper function to normalize titles
  const normalizeTitle = (title) => {
    return title
      .toLowerCase()
      .replace(/\s+/g, "") // Remove spaces
      .replace(/ä/g, "ae") // Replace umlauts
      .replace(/ö/g, "oe")
      .replace(/ü/g, "ue")
      .replace(/ß/g, "ss");
  };

  // Iterate through the steps and add fieldName
  steps.forEach((step) => {
    if (step.title) {
      step.fieldName = normalizeTitle(step.title);
    }
  });

  return steps;
};


export default {
  background_img: "",
  backend: {
    api: "",
  },
  claims: [
    {
      text: "",
      icon: "https://www.fs-energieberater.de/img/sublogo-80-mio-energie-wechsel.png",
    },
    {
      text: "",
      icon: "https://www.fs-energieberater.de/img/karussell_deutschland_machts_effizient_optimized.png",
    },
  ],
  certsImage: "/libs/wizard/check/img/zert.png",
  steps: [
    
    ...addFieldNameToSteps(startSteps),

    ...addFieldNameToSteps(waermepumpeEignungsAnalyse),

    ...addFieldNameToSteps(heizungswegweiser),

    ...addFieldNameToSteps(foerderung),

    ...addFieldNameToSteps(energieberatung),

    {
      id: 998,
      type: "map-locator-step",
      description: "PLZ",
      isSharedStep: true,
      title: "Postleitzahl des Gebäudestandortes",
      fieldName: "Vollständige_Addresse",
      options: [
        {
          id: "0",
          next: 999,
          prev: "nil",
          options: {
            default: "",
            text: "Adresse",
            description:
              "Geben Sie die gesamte fünfstellige Postleitzahl ein, auch bei Postleitzahlen mit einer Null an erster Stelle (0xxxx, wie zum Beispiel in Sachsen).",
            icon: "/libs/wizard/check/svg/map.png",
            placeholder: "Musterstr. 1, 12345 Stadt",
            button_title: "Weiter",
            isValidationDisabled: true,
          },
        },
      ],
    },
    {
      id: 999,
      type: "send-step",
      description: "send data",
      title: "Kostenlose und unverbindliche Energieberatung anfordern.",
      isSharedStep: true,
      sideImg: "/img/berater-vor-ort--optimized.jpg",
      options: [
        {
          id: "0",
          next: 1000,
          text: "",
          button_title: "Kostenlose Beratung anfordern",
          description:
            'Dieser Service ist kostenfrei. Mit Klick auf "Angebot erhalten" bestätigen Sie die Kenntnisnahme unserer\
          <a className=""\
          href=""\
          target="_blank">AGBs</a> und <a\
          className="" href=""\
          target="_blank">Datenschutzbestimmungen</a>',
          skipJavascriptCallback: true,
        }],
    },
    {
      "id": 1000,
      "type": "confirmation-step",
      "description":"send data",
      "title": "Danke! Wir haben Ihre kostenlose Anfrage erhalten.",
      "picture_title": "Dennis Fleischmann",
      "picture_subtitle":"Experte für Energie-Effizienz",
      "img":"/img/berater-vor-ort--optimized.jpg",
      "html_text":"\
      <p class=\"wui cs-main-content-line\"><span class=\"wui cs-main-content-line-styled\">Sehr geehrter Interessent,</span></p>\
      <p class=\"wui cs-main-content-line\">Ein Experte für Energie-Effizienz wird sich umgehend um Ihre Angelegenheit kümmern.</p>\
      <p class=\"wui cs-main-content-line\">Mit freundlichen Grüßen<span class=\"wui cs-main-content-line-styled\">Dennis Fleischmann</span></p>\
      "
    }
  ],
};
